import styled from "styled-components";

export const NotFoundPage = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  > main {
    width: min(100% - 48px, 760px);
    margin: 0 auto;
    padding: 18vh 0 14vh;
    flex: 1;
  }
`;

export const NotFoundTitle = styled.h1`
  margin: 0;
  color: var(--heading);
  font-size: clamp(42px, 8vw, 88px);
  font-weight: 400;
  line-height: 1.02;
  letter-spacing: -0.04em;
`;

export const NotFoundCopy = styled.p`
  max-width: 520px;
  margin: 28px 0 0;
  color: var(--subtle);
  font-size: 18px;
  line-height: 1.6;
`;

export const NotFoundActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px 28px;
  margin-top: 34px;

  a {
    color: var(--project-link);
    font-size: 16px;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;
